
import { Button, IconButton, ModalWindow } from "@/shared/ui";
import { defineComponent } from "vue";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "EditCharacterInfo",
	components: { IconButton, Button, ModalWindow },
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);
		const { updateName, updateRace, updateLuck } = store;

		return {
			characters,
			current,
			updateName,
			updateRace,
			updateLuck,
		};
	},
	data() {
		return {
			modal: false,
			name: "",
			race: "",
			luck: 0,
		};
	},
	computed: {
		isValidData(): boolean {
			return !!(this.name && this.race);
		},
	},
	watch: {
		modal(value) {
			if (!value) {
				return;
			}
			this.luck = this.characters[this.current].luck;
			this.name = this.characters[this.current].name;
			this.race = this.characters[this.current].race;
		},
	},
	methods: {
		close() {
			this.modal = false;
			this.name = "";
			this.race = "";
			this.luck = 0;
		},
		save() {
			this.updateName(this.name);
			this.updateRace(this.race);
			this.updateLuck(this.luck);
			this.modal = false;
		},
	},
});
